import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import clsx from 'clsx'
import { ChevronDown, SyncProgress, XCircle } from '@/assets/icons'
import { MenuContent, MenuItemGroup } from '@/components/menu/MenuContent'
import { MenuItem } from '@/components/menu/MenuItem'
import { getAccountStatusMeta } from '@/settings/components/connected-account-status-meta'
import { ConnectedAccount } from '@/settings/schemas/external-storage-schema'
import { PROVIDER_META } from '@/user_files/external-storage/ProviderMeta'

export default function ConnectedAccountRow({
  account,
  onDisconnect,
  onReconnect,
  loading,
}: {
  account: ConnectedAccount
  onDisconnect: () => void
  onReconnect: () => void
  loading: boolean
}) {
  const meta = PROVIDER_META[account.provider]
  const statusMeta = getAccountStatusMeta(account.status)

  return (
    <div className="flex items-center gap-4 px-4 py-4">
      <div className="flex h-[60px] w-[60px] shrink-0 items-center justify-center rounded-md border border-brand-neutral-200 bg-white">{meta.modalIcon}</div>
      <div className="min-w-0 flex-1">
        <p className="text-base font-semibold leading-7 tracking-normal text-brand-neutral-950">{meta.label}</p>
        <p className="text-sm leading-5 tracking-[-0.15px] text-brand-neutral-600">{statusMeta.helpText}</p>
      </div>

      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <button
            type="button"
            disabled={loading}
            className="flex shrink-0 items-center gap-1 rounded-md px-1.5 py-1 text-sm font-medium leading-5 tracking-[-0.15px] text-brand-neutral-950 transition-colors hover:bg-brand-neutral-100 disabled:cursor-not-allowed disabled:opacity-50"
            aria-label={`${meta.label} connection options`}
          >
            <span className={clsx('h-[7px] w-[7px] rounded-full', statusMeta.dotClassName)} aria-hidden="true" />
            {statusMeta.label}
            <ChevronDown className="h-4 w-4" aria-hidden="true" />
          </button>
        </DropdownMenu.Trigger>
        <MenuContent align="end" className="min-w-[120px]">
          <MenuItemGroup>
            {account.status !== 'connected' && <MenuItem label="Reconnect" icon={SyncProgress} variant="neutral" onSelect={onReconnect} disabled={loading} />}
            <MenuItem label="Disconnect" icon={XCircle} variant="destructive" onSelect={onDisconnect} disabled={loading} />
          </MenuItemGroup>
        </MenuContent>
      </DropdownMenu.Root>
    </div>
  )
}
